import api from './APIService';

class EmergencyContactService {
	/*getAll(userId) {
		return api.fetch({ method: 'get', path: `/participant/emergencyContact/${userId}` });
	}*/
	create(data) {
		return api.fetch({ method: 'post', path: '/participant/emergencyContact/', data: data });
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/emergencyContact/', data: data });
	}
	delete(userId, id) {
		return api.fetch({ method: 'delete', path: `/participant/emergencyContact/${userId}/${id}` });
	}
	getMultipleEmergencyContact(data) {
		return api.fetch({ method: 'post', path: '/participant/emergencyContact/getMultipleEmergencyContact', data });
	}
	getEmergencyContactsUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/emergencyContact/getEmergencyContactsForUsers', data });		
	}
}

export default new EmergencyContactService();
